// Where our room server lives. On our own domain it's same-origin (/ws); everywhere else (CrazyGames serves the client
// from its own CDN, the local lab) it's the production host. ?server=<url> overrides for local testing.

const PROD = "normaltown.whalewars.space";
const qs = new URLSearchParams(location.search);
const override = qs.get("server");
const sameOrigin = location.hostname === PROD;
const local = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);

/** https base for REST (telemetry, board) — "" disables network extras */
export const HTTP_BASE = override ? override.replace(/^ws/, "http").replace(/\/$/, "") : sameOrigin ? `${location.origin}/ws` : local && !qs.has("prod") ? "" : `https://${PROD}/ws`;
/** websocket base for the Colyseus room */
export const WS_BASE = override ? override.replace(/^http/, "ws").replace(/\/$/, "") : sameOrigin ? `wss://${PROD}/ws` : local && !qs.has("prod") ? "" : `wss://${PROD}/ws`;
